import React from 'react';
import { Formik, Form, Field, FormikHelpers } from 'formik';
import useReactRouter from 'use-react-router';
import { parse } from 'querystring';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { TextField } from 'formik-material-ui';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import FormHelperText from '@material-ui/core/FormHelperText';

import CommonContainer from '../../containers/Common';
import { useTranslation } from 'react-i18next';

interface FormValues {
  userName: string;
  password: string;
}

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default (() => {
  const {t} = useTranslation();

  const commonContainer = CommonContainer.useContainer();
  const { history, location } = useReactRouter();
  const classes = useStyles();

  var handleSubmit = async (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
    try {
      await commonContainer.login(values.userName, values.password);

      var query = parse(location.search.substr(1));
      var url = (query.redirect || '/console/stock-order') as string;
      history.push(url);
    } catch (err) {
      if (err.status === 403) {
        formikHelpers.setStatus('Invalid User Name or Password');
      } else {
        formikHelpers.setStatus('Unhandled error');
      }

      formikHelpers.setSubmitting(false);
    }
  }

  return (
    <Formik
      initialValues={{ userName: '', password: '' }}
      onSubmit={handleSubmit}>
      {({ status, isSubmitting }) => (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              {t('signIn')}
            </Typography>
            <Form className={classes.form} noValidate>
              <FormHelperText error={true}>{status}</ FormHelperText>
              <Field
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="userName"
                label={t('userName')}
                name="userName"
                autoFocus
                component={TextField} />
              <Field
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label={t('password')}
                type="password"
                id="password"
                autoComplete="current-password"
                component={TextField} />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={isSubmitting}
                className={classes.submit}
              >
                {t('signIn')}
              </Button>
            </Form>
          </div>
        </Container>
      )}
    </Formik>
  )
}) as React.FC;
